import request from "../base/request";
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName() + '/';

const Apis = {
    getPublishData: host + 'manuscript/getManuscriptByStatus',//获取已发布列表
    withdraw: host + 'manuscript/withdraw', //撤回
    delManuscript: host + 'manuscript/delManuscript', //删除
};

//获取已发布列表
export const getPublishData = (body, callBack) => {
    request({url:Apis.getPublishData, body, callBack});
}

//撤回稿件
export const withdraw = (body, callBack) => {
    request({url:Apis.withdraw, body, callBack});
}

//删除稿件
export const delManuscript = (body, callBack) => {
    request({url:Apis.delManuscript, body, callBack});
}
